/**
 * @fileOverview Holds the state on whether or not the files in state have
 * been committed or not.
 * e.g. {
 *  'fileId_1234': true, // This file is uncommitted
 * }
 */

function reducer(state = {}, action){

  if (action.type == 'UPDATE_FILE_CONTENT'){
    const { fileId } = action.payload
    state = Object.assign({}, state)
    state[fileId] = true
  }

  if (action.type == 'SAVE_FILES' || action.type == 'CREATE_BRANCH_AND_SAVE_FILES'){
    const { files } = action.payload
    files.forEach(({ id }) => {
      state = Object.assign({}, state)
      delete state[id]
    })
  }

  return state
}

export default reducer


// WEBPACK FOOTER //
// ./src/store/uncommitted/reducer.js